var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs2/core-js/object/define-property", "@babel/runtime-corejs2/core-js/object/define-properties", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor", "@babel/runtime-corejs2/core-js/object/get-own-property-symbols", "@babel/runtime-corejs2/core-js/object/keys", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/assertThisInitialized", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "@babel/runtime-corejs2/helpers/defineProperty", "react", "prop-types", "emotion-theming", "../../propTypes", "../Button/Button", "../Icon/Icon", "../../Tracking", "../../css", "./NextSharebar.css"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs2/core-js/object/define-property"), require("@babel/runtime-corejs2/core-js/object/define-properties"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"), require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"), require("@babel/runtime-corejs2/core-js/object/keys"), require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/assertThisInitialized"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("react"), require("prop-types"), require("emotion-theming"), require("../../propTypes"), require("../Button/Button"), require("../Icon/Icon"), require("../../Tracking"), require("../../css"), require("./NextSharebar.css"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.defineProperties, global.getOwnPropertyDescriptors, global.getOwnPropertyDescriptor, global.getOwnPropertySymbols, global.keys, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global.classCallCheck, global.createClass, global.assertThisInitialized, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.defineProperty, global.react, global.propTypes, global.emotionTheming, global.propTypes, global.Button, global.Icon, global.Tracking, global.css, global.NextSharebar);
    global.NextSharebar = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _defineProperties, _getOwnPropertyDescriptors, _getOwnPropertyDescriptor, _getOwnPropertySymbols, _keys, _es6Regexp, _es6Date, _es6Object, _construct, _classCallCheck2, _createClass2, _assertThisInitialized2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _defineProperty3, _react, _propTypes, _emotionTheming, _propTypes2, _Button, _Icon, _Tracking, _css, _NextSharebar) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty2(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _defineProperties = _interopRequireDefault(_defineProperties);
  _getOwnPropertyDescriptors = _interopRequireDefault(_getOwnPropertyDescriptors);
  _getOwnPropertyDescriptor = _interopRequireDefault(_getOwnPropertyDescriptor);
  _getOwnPropertySymbols = _interopRequireDefault(_getOwnPropertySymbols);
  _keys = _interopRequireDefault(_keys);
  _construct = _interopRequireDefault(_construct);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _defineProperty3 = _interopRequireDefault(_defineProperty3);
  _react = _interopRequireWildcard(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _propTypes2 = _interopRequireDefault(_propTypes2);
  _Button = _interopRequireDefault(_Button);
  _Icon = _interopRequireDefault(_Icon);

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

  var providers = ['facebook', 'twitter', 'whatsapp'];

  var getLocationHref = function getLocationHref() {
    return 'location' in global && 'href' in global.location ? global.location.href : '';
  };

  var getProvider = function getProvider(transformer, provider, urlToShare) {
    var share = {};
    var encodedUrl = encodeURIComponent(urlToShare);
    var baseUrl = '//static-cdn.arte.tv/static/styleguide/latest/img/next-sharebar';

    switch (provider) {
      case 'twitter':
        share.url = "https://twitter.com/intent/tweet?url=".concat(encodedUrl);
        share.image = "".concat(baseUrl, "/twitter.svg");
        break;

      case 'whatsapp':
        share.url = "whatsapp://send?text=".concat(encodedUrl);
        share.image = "".concat(baseUrl, "/whatsapp.svg");
        break;

      default:
        // facebook by default
        share.url = "https://www.facebook.com/sharer/sharer.php?u=".concat(encodedUrl);
        share.image = "".concat(baseUrl, "/facebook.svg");
        break;
    }

    return _objectSpread(_objectSpread({}, share), {}, {
      url: transformer(provider, urlToShare, share.url)
    });
  };

  var themes = {
    dark: {
      backgroundColor: (0, _css.palette)('primary', 'mainNav'),
      borderTop: "".concat((0, _css.remCalc)(10), " solid ").concat((0, _css.palette)('primary', 'mainNav'))
    },
    light: {
      backgroundColor: (0, _css.palette)('primary', 'mainDivider'),
      borderTop: "".concat((0, _css.remCalc)(10), " solid ").concat((0, _css.palette)('primary', 'mainDivider'))
    }
  };

  var NextSharebar = /*#__PURE__*/function (_PureComponent) {
    (0, _inherits2.default)(NextSharebar, _PureComponent);

    var _super = _createSuper(NextSharebar);

    // == Ref to the share window
    function NextSharebar(props) {
      var _this;

      (0, _classCallCheck2.default)(this, NextSharebar);
      _this = _super.call(this, props);
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "onSharebarToggle", function () {
        if (_this.state.loading === false) {
          _this.setState(function (prevState) {
            return {
              sharebarOpen: !prevState.sharebarOpen
            };
          });
        }
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "openUrl", function (event, url, provider) {
        event.preventDefault();
        var trackingEnabled = _this.props.trackingEnabled;

        try {
          if (NextSharebar.windowReference) {
            NextSharebar.windowReference.close();
          }

          NextSharebar.windowReference = global.open(url);

          if (trackingEnabled) {
            (0, _Tracking.send)({
              target: null,
              click_name: provider,
              click_type: 'exit',
              categories: ['Share']
            });
          }

          _this.onSharebarToggle();
        } catch (e) {
          console.log(e);
        }
      });
      _this.state = {
        sharebarOpen: false,
        loading: true,
        errored: false
      };
      return _this;
    }

    (0, _createClass2.default)(NextSharebar, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        setTimeout(function () {
          return _this2.setState({
            loading: false
          });
        }, 250);
      }
    }, {
      key: "render",
      value: function render() {
        var _this3 = this;

        var _this$props = this.props,
            labels = _this$props.labels,
            sharedLinkBack = _this$props.sharedLinkBack,
            theme = _this$props.theme,
            transformer = _this$props.transformer,
            label = _this$props.label,
            loadingLabel = _this$props.loadingLabel;

        if (label) {
          labels.share = label;
        }

        if (loadingLabel) {
          labels.loading = loadingLabel;
        }

        var styles = this.state.errored ? {
          display: 'none'
        } : {};
        styles.opacity = this.state.loading ? 0.25 : 1;
        return /*#__PURE__*/_react.default.createElement(_emotionTheming.ThemeProvider, {
          theme: themes[theme] || themes.dark
        }, /*#__PURE__*/_react.default.createElement(_NextSharebar.StyledSharebar, {
          className: "next-sharebar"
        }, /*#__PURE__*/_react.default.createElement(_Button.default, {
          ariaExpanded: this.state.sharebarOpen,
          icon: /*#__PURE__*/_react.default.createElement(_Icon.default, {
            name: "arte-next-share",
            size: "small",
            color: "white",
            colorTone: "base"
          }),
          label: this.state.loading ? labels.loading : labels.share,
          onClick: this.onSharebarToggle,
          type: "button",
          style: {
            backgroundColor: themes[theme].backgroundColor
          }
        }), /*#__PURE__*/_react.default.createElement(_NextSharebar.StyledIcons, {
          expanded: this.state.sharebarOpen
        }, providers.map(function (provider) {
          var _getProvider = getProvider(transformer, provider, sharedLinkBack || getLocationHref()),
              image = _getProvider.image,
              url = _getProvider.url;

          return /*#__PURE__*/_react.default.createElement(_NextSharebar.StyledLink, {
            provider: provider,
            href: url,
            key: provider,
            onClick: function onClick(event) {
              return _this3.openUrl(event, url, provider);
            },
            tabIndex: _this3.state.sharebarOpen ? 0 : -1
          }, /*#__PURE__*/_react.default.createElement(_NextSharebar.StyledImage, {
            src: image,
            alt: provider
          }));
        }), /*#__PURE__*/_react.default.createElement(_NextSharebar.StyledTriangle, null))));
      }
    }]);
    return NextSharebar;
  }(_react.PureComponent);

  (0, _defineProperty3.default)(NextSharebar, "windowReference", null);
  NextSharebar.propTypes = {
    labels: _propTypes.default.shape({
      share: _propTypes.default.string,
      loading: _propTypes.default.string
    }),
    label: _propTypes2.default.deprecated(_propTypes.default.string, 'Please use labels.share instead of this prop'),
    loadingLabel: _propTypes2.default.deprecated(_propTypes.default.string, 'Please use labels.loading instead of this prop'),
    sharedLinkBack: _propTypes.default.string,
    theme: _propTypes.default.oneOf(['dark', 'light']),
    trackingEnabled: _propTypes.default.bool,
    transformer: _propTypes.default.func
  };
  NextSharebar.defaultProps = {
    labels: {
      share: 'Share',
      loading: 'Loading...'
    },
    sharedLinkBack: '',
    theme: 'dark',
    trackingEnabled: false,
    transformer: function transformer(provider, url, shareUrl) {
      return shareUrl;
    }
  };
  var _default = NextSharebar;
  _exports.default = _default;
});